import React, { useEffect, useState } from 'react';
import { Button, Image, Tag } from '@arco-design/web-react';
import _ from 'lodash';
import './sider.less';

import { useHistory } from 'react-router-dom';
import { appStore } from '@/mobx';
import expand_logo from '@/assets/expand_logo.png';
import ClientTabs from '@/mobx/modules/tabStore';
import { observer } from 'mobx-react-lite';

const Sider: React.FC = () => {
  const history = useHistory();

  // 搜索表单
  const [version, setVersion] = useState('');
  const [isDebug, setIsDebug] = useState(false);
  const [clickCount, setClickCount] = useState(0); // 点击次数

  const getClientInfo = async () => {
    console.log(
      'getClientInfo===================>',
      window?.electron?.ipcRenderer?.getVersion().then((res) => {
        console.log('getVersion----------------', res);
      })
    );

    if (window?.electron?.ipcRenderer?.getVersion) {
      const res = await window.electron.ipcRenderer?.getVersion();
      window.electron.log(
        `===============================用户使用的版本是: ${res}======================================`
      );
      setVersion(res);
    }

    if (window.electron?.ipcRenderer?.getIsDebug) {
      window.electron.ipcRenderer.getIsDebug().then((res) => {
        console.log('getIsDebug=========>', res);
        setIsDebug(res);
      });
    }
  };

  const handleOpenFolder = () => {
    setClickCount((prevCount) => prevCount + 1);
  };

  useEffect(() => {
    getClientInfo();
  }, []);

  // 当点击次数达到5次时，打开日志文件夹
  useEffect(() => {
    if (clickCount === 5) {
      // 打开文件夹
      if (window.electron && window.electron.ipcRenderer.openFolder) {
        window.electron.ipcRenderer.openFolder();
      }
      // 重置点击次数
      setClickCount(0);
    }
  }, [clickCount]);

  return (
    <div className="matrix-nav">
      <img
        src={
          appStore.isZhaiXing ? expand_logo : appStore.config?.web?.app?.logo
        }
        alt=""
        width={180}
        height={36}
        style={{ padding: '20px 4px', cursor: 'pointer' }}
        onClick={() => {
          history.push('/matrix');
          ClientTabs.setActivePath(0);
          // discreteScroll(-1000);
        }}
      />
      <div className="nav_title">授权平台</div>
      {appStore.navList.map((item) => (
        <div
          key={item.key}
          className="nav_list"
          style={{ margin: '6px 0' }}
          onClick={() => {
            history.replace('/matrix');
            appStore.setPlatformId(item.meta?.platform || 1);
            ClientTabs.setActivePath(0);
          }}
        >
          <div
            className={
              appStore.platformId === (item.meta?.platform || 1)
                ? 'nav_list_item nav_active'
                : 'nav_list_item'
            }
          >
            <Image src={item.meta?.icon} width={22} preview={false} />
            {item.name}{' '}
            <span
              style={{
                color:
                  appStore.platformId === (item.meta?.platform || 1)
                    ? '#fff'
                    : '#aaa',
                fontSize: 14,
              }}
            >
              ({item.meta?.authNum || 0}/{appStore.maxAuthNum})
            </span>
          </div>
        </div>
      ))}
      {/* <Button
        onClick={() => {
          history.replace('/ai-auth');
        }}
      >
        AI平台授权
      </Button> */}
      {window.electron && (
        <div
          style={{
            position: 'absolute',
            bottom: 20,
            left: 0,
            right: 0,
            display: 'flex',
            justifyContent: 'center',
            color: '#888',
            fontSize: 12,
            userSelect: 'none',
          }}
          onClick={handleOpenFolder}
        >
          <span style={{ marginRight: 8 }}>版本：v{version}</span>
          {isDebug ? (
            <Tag color={'red'} size="small">
              dev
            </Tag>
          ) : null}
        </div>
      )}
    </div>
  );
};
export default observer(Sider);
